import cookies from 'vue-cookies'
import { COOKIES_DOMAIN } from '@/utils/modules/Common'

const Cookies = {
	set: (key, value) => {
		cookies.set(key, value, null, null, COOKIES_DOMAIN)
	},
	get: key => {
		return cookies.get(key)
	},
	remove: key => {
		cookies.remove(key)
	},
	keys: () => {
		return cookies.keys()
	},
}

export default Cookies
